<ng-container *ngIf="needsLinking; else setupComplete">
  <h2 class="wizard_step-title text--title-bold">{{ 'deviceCode' | translate | titlecase }}</h2>

  <div class="pairing-code">
    <div class="pairing-code_label">{{ 'pairingCode' | translate | titlecase }}</div>
    <div class="pairing-code_value">{{ pairingCode }}</div>
    <div class="pairing-code_help">{{ 'pairingCodeHelp' | translate }}</div>
  </div>
</ng-container>

<ng-template #setupComplete>
  <h2 class="wizard_step-title text--title-bold">{{ 'success' | translate }}</h2>

  <div class="setup-success">
    <div class="setup-success_message">{{ 'homeSetupCreateSuccess' | translate }}</div>
  </div>
</ng-template>

<div class="wizard_footer">
  <button class="button button--primary" type="button" (click)="done.emit()">
    <span class="regular">{{ 'done' | translate }}</span>
  </button>
</div>
